export default __webpack_public_path__ + "static/media/spark_29.3fa68990.png";